/**
 * Labstep
 *
 * @module core/Card/Element
 * @desc Generic Card for Interactive Elements in Protocols / Experiments for use in the Overview side panel.
 */

import classnames from 'classnames';
import { Card } from 'labstep-web/core/Card/Card';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { IElementCardProps } from './types';

export const ElementCard: React.FC<IElementCardProps> = ({
  name,
  icon,
  right,
  detail,
  actions,
  customIcon,
  onClick,
  isLink,
  dataCy,
  basic = false,
  dragHandle,
}) =>
  basic ? (
    <div
      className={styles.elementCard}
      style={{ padding: 0 }}
      data-cy={dataCy}
    >
      {dragHandle && (
        <span className={styles.dragHandle}>{dragHandle}</span>
      )}
      <div>
        <div>{customIcon || (icon && <Icon name={icon} />)}</div>
        <Flex
          wrap
          grow
          vAlignContent="center"
          className={styles.elementCardDetail}
        >
          <div
            data-cy="core/Card/Element:name"
            data-private
            className={classnames(styles.elementCardName, {
              [styles.clickable]: onClick,
              [styles.link]: isLink,
            })}
            onClick={onClick}
          >
            {name}
          </div>
          <div>{detail}</div>
        </Flex>
      </div>
      <div
        className={styles.elementCardRight}
        data-cy="core/Card/Element:right"
      >
        {right}
        {actions}
      </div>
    </div>
  ) : (
    <Card className={styles.elementCard}>
      {dragHandle && (
        <span className={styles.dragHandle}>{dragHandle}</span>
      )}
      <div data-cy={dataCy}>
        <div>{customIcon || (icon && <Icon name={icon} />)}</div>
        <Flex
          wrap
          grow
          vAlignContent="center"
          className={styles.elementCardDetail}
        >
          <div
            data-cy="core/Card/Element:name"
            data-private
            className={classnames(styles.elementCardName, {
              [styles.clickable]: onClick,
              [styles.link]: isLink,
            })}
            onClick={onClick}
          >
            {name}
          </div>
          <div>{detail}</div>
        </Flex>
      </div>
      <div
        className={styles.elementCardRight}
        data-cy="core/Card/Element:right"
      >
        {right}
        {actions}
      </div>
    </Card>
  );
